import { DotLegalEmptyState, DotLegalOverflowMenu, DotLegalPaper, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation.ts";
import { FrameworkCategoryViewModel } from "./FrameworkCategories.types.ts";
import NoSharings from "../../processingActivity/processingActivityOverview/processingActivitySharingsTab/noSharings.svg?react";

export interface FrameworkCategoryTableProps {
    isLoading: boolean;
    data: Array<FrameworkCategoryViewModel> | undefined;
    onUpdateCategoryClick?: (categoryId: string) => void;
    onDeleteCategoryClick?: (categoryId: string) => void;
}

function FrameworkCategoryTable(props: FrameworkCategoryTableProps) {
    const { translateString } = useTranslation();
    function getHeaders() {
        let headers = Array<ITableHeader<FrameworkCategoryViewModel>>();
        headers.push({ property: "name", text: translateString("name"), align: "left", showOnMobile: true });
        headers.push({ property: "customId", text: translateString("id"), align: "left", showOnMobile: true });
        headers.push({ property: "description", text: translateString("description"), align: "left", showOnMobile: true });

        return headers;
    }

    const getMenuItems = (category: FrameworkCategoryViewModel) => {
        let menuItems = [];

        if (props.onUpdateCategoryClick) {
            menuItems.push({
                menuItem: translateString("edit"),
                onClick: () => {
                    props.onUpdateCategoryClick!(category.id);
                },
            });
        }

        if (props.onDeleteCategoryClick) {
            menuItems.push({
                menuItem: translateString("delete"),
                onClick: () => {
                    props.onDeleteCategoryClick!(category.id);
                },
            });
        }

        return menuItems;
    };

    return (
        <DotLegalPaper>
            {props.isLoading || (props.data?.length ?? 0) > 0 ? (
                <DotLegalTableWithControls
                    getUserSpecificPageLength={() => 9999}
                    labelRowsPerPage={""}
                    labelSearch={translateString("search")}
                    hideRowsPerPage
                    hasOverflowMenu={!!(props.onUpdateCategoryClick || props.onDeleteCategoryClick)}
                    noOptionsLabel={""}
                    emptyText={translateString("noCategoriesMatchesQuery")}
                    headers={getHeaders()}
                    isLoading={props.isLoading}
                    defaultOrderBy={"name"}
                    data={props.data ?? []}
                    renderRow={(row, index) => {
                        const menuItems = getMenuItems(row);
                        return (
                            <TableRow key={row.id}>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.customId}</TableCell>
                                <TableCell>{row.description}</TableCell>
                                {menuItems.length > 0 && <TableCell align={"right"}>{<DotLegalOverflowMenu items={menuItems} />}</TableCell>}
                            </TableRow>
                        );
                    }}
                />
            ) : (
                <DotLegalEmptyState icon={<NoSharings />} text={translateString("noCategoriesFound")} />
            )}
        </DotLegalPaper>
    );
}

export default FrameworkCategoryTable;
